import { usePublicContent } from "@/lib/useContent";
import { cn } from "@/lib/utils";

// Renders admin-managed editable sections for a given page
export const PageSections = ({ page }) => {
  const { data } = usePublicContent("page_sections");
  const sections = data.filter((s) => s.page === page);
  if (sections.length === 0) return null;
  return (
    <section className="bg-background py-16 sm:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 space-y-12">
        {sections.map((s, i) => (
          <div key={s.id} className={cn("grid items-center gap-8 md:grid-cols-2")}>
            {s.image_url && (
              <div className={cn("overflow-hidden rounded-xl", i % 2 === 1 && "md:order-2")}>
                <img src={s.image_url} alt={s.heading} loading="lazy" className="h-64 w-full object-cover md:h-80" />
              </div>
            )}
            <div className={cn(!s.image_url && "md:col-span-2", i % 2 === 1 && "md:order-1")}>
              {s.heading && <h3 className="display-title text-3xl sm:text-4xl">{s.heading}</h3>}
              {s.body && <p className="mt-3 whitespace-pre-wrap text-muted-foreground leading-relaxed">{s.body}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
